import { useRef } from "react";
import { usePlaidLink } from "react-plaid-link";
import PlaidLinkWrapper from "./PlaidLinkWrapper";

/**
 * useMockPlaidLink
 * Currently just set up to immediatly call the onSuccess
 * callback with "some-token".
 * Can be customized further if we need to
*/
const useMockPlaidLink = ({ onSuccess }) => {
  const hasOnSuccessBeenCalled = useRef(false);
  return {
    open: () => {
      if (hasOnSuccessBeenCalled.current) return;
      console.log("mockUsePlaidLink, open called"); // eslint-disable-line no-console
      if (onSuccess) {
        onSuccess("some-token");
        hasOnSuccessBeenCalled.current = true;
      }
    },
    ready: true,
    error: null,
  };
};

/**
 * PlaidLinkWrapperOrMockLinkWrapper
 * This is mainly here to allow us to test an
 * INVALID_ADDRESS error from 'PUT /v1/banking/plaid'
 * which we can only do in an e2e Playwright test
 * by not only mocking out our server-to-server calls to Plaid,
 * but also our use of their react lib in our UI.
 * This passes along our own mock, if the plaidLinkToken
 * is a value we expect to come from our server mocks
*/
const PlaidLinkWrapperOrMockLinkWrapper = (props) => {
  return (
    <PlaidLinkWrapper
      {...props}
      usePlaidLink={props.plaidLinkToken === "some-link-token" ? useMockPlaidLink : usePlaidLink} // "some-link-token" is the value that comes back from the fake-integrator Plaid mocks
    />
  );
};

export default PlaidLinkWrapperOrMockLinkWrapper;
